import { render, staticRenderFns } from "./SelectionMassModificationModal.vue?vue&type=template&id=53ddb67c&"
import script from "./SelectionMassModificationModal.vue?vue&type=script&lang=js&"
export * from "./SelectionMassModificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports